/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["kxv",[["a","p"],["am","pm"]],u,[["aa","s","ma","pu","la","su","sa"],["aadi","smba","manga","puda","laki","sukru","sani"],["aadi vara","smbara","mangaḍa","pudara","laki vara","sukru vara","sani vara"],["aa","s","ma","pu","laki","su","sa"]],u,[["pu","ma","pa","hi","be","ja","aa","sra","b","da","di","pa"],["pusu","maha","pagu","hire","bese","jaṭṭa","aasaḍi","srabĩ","bado","dasara","divi","pande"],["pusu lenju","maha lenju","pagu lenju","hire lenju","bese lenju","jaṭṭa lenju","aasaḍi lenju","srabĩ lenju","bado lenju","dasara lenju","divi lenju","pande lenju"]],u,[["bc","ad"],u,["krisṭ purb nki","krisṭabd"]],0,[0,0],["d/M/yy","d MMM y","d MMMM y","EEEE, d MMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##,##0.###","#,##0%","¤#,##,##0.00","#E0"],"INR","₹","bārat ti ṭnkā",{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
